import React from 'react';
import { Link } from 'react-router-dom';
import { IconDropDown, IconProfile } from '@assets/icons';
import { PATH_URL_PC } from '@common/config/pathURL';
import cache, { sessionCache } from '@common/utils/cache';
import { Dropdown, Layout, Menu, Row } from 'antd';
import PropTypes from 'prop-types';
import Breadcrumb from './Breadcrumb';

function Header({ profile }) {
  const handleLogout = () => {
    if (cache.get('token')) {
      cache.remove('token');
      cache.remove('refreshToken');
    } else {
      sessionCache.remove('token');
      sessionCache.remove('refreshToken');
    }
  };
  const menuItems = [
    {
      label: <Link to={PATH_URL_PC.ACCOUNT}>アカウント情報</Link>,
      key: '1',
    },
    {
      label: (
        <Link onClick={handleLogout} to={PATH_URL_PC.LOGIN}>
          ログアウト
        </Link>
      ),
      key: '2',
    },
  ];

  return (
    <Layout.Header className="layout-wraper-header">
      <Row justify="space-between" align="middle" className="header-content">
        <Breadcrumb />
        <Row align="middle" className="group-profile">
          <div className="avatar" />
          <Dropdown
            overlayClassName="dropdown-profile"
            overlay={<Menu items={menuItems} />}
            trigger={['click']}
            placement="bottomRight"
          >
            <Row align="middle" className="fw-700">
              <IconProfile className="mr-8" />
              {profile?.userNm}
              <IconDropDown className="ml-20" />
            </Row>
          </Dropdown>
        </Row>
      </Row>
    </Layout.Header>
  );
}

export default Header;

Header.propTypes = {
  profile: PropTypes.object,
};
